import React, { FC } from 'react';
import { history } from 'umi';
import { Spin } from 'antd';
import { Space } from 'antd';
import useMobile from '@/hooks/useMobile';
import { BackButton } from '@/components/back-button/back-button';
import classnames from 'classnames';
import './index.less';

interface IProps {
  title?: React.ReactNode;
  loading?: boolean;
  subTitle?: React.ReactNode;
  onBack?: () => void;
  className?: string;
  children: React.ReactNode;
}

const PageFrame: FC<IProps> = ({
  title,
  loading = false,
  subTitle,
  onBack,
  className,
  children,
}) => {
  const isMobile = useMobile();

  const handleBack = () => {
    if (typeof onBack === 'function') {
      onBack();
    } else {
      history.goBack();
    }
  };

  return (
    <div
      className={classnames('page-frame-container', {
        [className as string]: !!className,
        'page-frame-container-isMobile': isMobile,
      })}
    >
      <BackButton handleClick={handleBack} />
      {title && (
        <Space className="page-frame-title" direction="vertical" size={4}>
          <div className="page-frame-title-title">{title}</div>
          {subTitle && <div className="page-frame-title-sub">{subTitle}</div>}
        </Space>
      )}
      <div className="page-frame-content">
        <Spin spinning={loading}>{children}</Spin>
      </div>
    </div>
  );
};

export default PageFrame;
